<template lang="pug">
  
	div.card.camada-ativa(:id="'camada-ativa' + camada.id")

		//- Linha contendo a legenda e nome da camada
		
		div.card-body

			div.col-camada-drag-icon
				i.mdi.mdi-drag-vertical.action-icon

			div.col-camada-legenda.collapsed(
					:class="{ 'cursor-pointer': camada.estilosPersonalizados \
							&& camada.estilosPersonalizados.length }",
					data-toggle="collapse",
					:href="'#legendas' + camada.id",
					aria-expanded="false", 
					:aria-controls="'legendas' + camada.id")

				div.camada-expand-icon(
						v-if="camada.estilosPersonalizados && camada.estilosPersonalizados.length")
					
					i.fa.fa-chevron-right.action-icon.pull-left
					i.fa.fa-chevron-down.action-icon.pull-left

				div.camada-expand-icon.collapsed(
						v-if="!camada.estilosPersonalizados || !camada.estilosPersonalizados.length")

					i.fa.fa-chevron-right.action-icon.pull-left.disabled

				icone-legenda(:estilo="camada.estiloPadrao",
					:camada="camada",
					:estilosPersonalizados="camada.estilosPersonalizados")

			div.col-camada-nome.card-text.text-truncate(:title="camada.nome") {{ camada.nome }}

			div.col-camada-remove.float-right
				i.mdi.mdi-close.action-icon.float-right(@click="removerCamada(camada)")

		
		//- Legendas para estilos personalizados

		ul.list-group.list-group-flush.camada-estilos-personalizados.collapse(
				:id="'legendas' + camada.id",
				v-if="camada.estilosPersonalizados && camada.estilosPersonalizados.length")

			li.list-group-item
				div.row
					div.col-md-3
						icone-legenda(:estilo="camada.estiloPadrao", :camada="camada")

					div.col-md-9.camada-descricao-legenda.pl-0 Padrão


			li.list-group-item(v-for="estilo in camada.estilosPersonalizados")

				div.row
					div.col-md-3
						icone-legenda(:estilo="estilo", :camada="camada")

					div.col-md-9.camada-descricao-legenda.pl-0
						
						span(v-for="(regra, index) in estilo.regras") 
							| {{ index > 0 ? ' e ' + regra.descricao : regra.descricao }}


</template>

<script>

import IconeLegenda from './IconeLegenda';

export default {
	name: 'Camadas',

	components: { IconeLegenda },

	props: {
		camada: Object
	},
	
	data () {
		return {

		};
	},

	methods: {

		removerCamada (camada) {

			this.$emit('remove');
		}
	}
};

</script>

<style lang="scss" scoped>

@import "../../styles/variaveis";
@import "../../styles/mixins";

$camadas-ativas-padding: 2px;
$camadas-ativas-inner-height: $camadas-ativas-height - (2 * $camadas-ativas-padding);
$camadas-ativas-estilos-inner-height: $camadas-ativas-estilos-height - (2 * $camadas-ativas-padding);

.card.camada-ativa {
	margin: 0 15px;

	.col-camada-drag-icon, .col-camada-legenda, .col-camada-nome, .col-camada-remove {
		display: block;
		float: left;
	}

	// Colunas do card de camada ativa
	.col-camada-drag-icon { width: 18px; }

	.col-camada-legenda { width: 62px; }

	.col-camada-remove { width: 26px; }

	.col-camada-nome {
		position: absolute;
		left: 80px;
		right: 26px;
	}

	.card-body {
		padding: $camadas-ativas-padding 0;
		
		.card-text {
			font-size: $camadas-nome-fonte-size;
			color: $camadas-nome-color;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			line-height: $camadas-ativas-inner-height;
			vertical-align: middle;
		}

		.legenda-icon {
			margin-left: 6px;
			margin-top: ($camadas-ativas-inner-height - $legenda-icon-size) / 2;
		}

		.col-camada-drag-icon {
			height: $camadas-ativas-inner-height;
			font-size: 18px;
			line-height: $camadas-ativas-inner-height;
			vertical-align: middle;
			color: $camadas-nome-color;
			@include cursor-hand();
			.action-icon { @include cursor-hand(); }
		}

		.camada-expand-icon {
			width: 14px;
			display: block;
			float: left;
			font-size: 10px;
			
			.fa {
				width: 100%;
				line-height: $camadas-ativas-inner-height;
				vertical-align: middle;
				text-align: center;
			}
			
			.fa.fa-chevron-right { display: none; }
			.fa.fa-chevron-down { display: inline; }
		}

		.collapsed {
			.camada-expand-icon .fa.fa-chevron-right { 
				
				display: inline; 
			}
			.camada-expand-icon .fa.fa-chevron-down { display: none; }
		}

		.cursor-pointer {
			cursor: pointer;
		}

		.mdi.mdi-close {
			display: block;
			height: $camadas-ativas-inner-height;
			padding-right: 5px;
			padding-left: 5px;
		}
	}

	.list-group.camada-estilos-personalizados {
		
		&.collapse {
			display: none;
			&.show { display: block; }
		}

		.camada-descricao-legenda {
			font-size: $legenda-descricao-font-size;
			color: $legenda-descricao-color;
		}

		li {
			padding: $camadas-ativas-padding 0;
			margin: 0;
			line-height: $camadas-ativas-estilos-inner-height;
			vertical-align: middle;
			& + li { border: none; }
			border-bottom: none;
			
			.legenda-icon {
				margin-left: 25px;
				margin-top: ($camadas-ativas-estilos-inner-height - $legenda-icon-size) / 2;
			}
		}
	}
}

.sortable-chosen .card.camada-ativa {
	background-color: transparent;
	opacity: 1;
}

.sortable-ghost .card.camada-ativa {
	background-color: $camadas-ativas-drag-ghost-color;
	height: 30px;
	border: none;
	
	* {
		display: none;
	}
}

</style>



// WEBPACK FOOTER //
// CamadaAtiva.vue?7193a4dc